<template>
  <div>

    <md-table v-model="platforme" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Ime">{{ item.platforma_naziv }}</md-table-cell>
        <md-table-cell md-label="Finansiranje">{{ item.platforma_financiranje_sektor }}</md-table-cell>
        <md-table-cell md-label="Opis">{{ item.platforma_opis }}</md-table-cell>
        <md-table-cell md-label="Država">{{ item.platforma_lokacija }}</md-table-cell>        
        <md-table-cell md-label="">
            <router-link :to="'/editplatform/'+item.uuid_platforma">Izmijeniti</router-link>
        </md-table-cell>        
      </md-table-row>
    </md-table>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ciste-platforme",
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  methods:{
  },
  data() {
    return {
      selected: [],
      httpOptions: "",
      platforme: []
    }
  },
  components: {
    
  },
  mounted: async function(){
    const token = await this.$auth.getTokenSilently()
       axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme",
       {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.platforme = response.data['Items']
        })) 
  },
  updated: function()
  {
  }
};
</script>
